import React from "react";
import { usePageDeliveryHook } from "./delivery-hooks";

type PageContextDelivery = ReturnType<typeof usePageDeliveryHook>;
export const DeliveryContext = React.createContext<PageContextDelivery | null>(
  null,
);

export function usePageContextDelivery() {
  const context = React.useContext(DeliveryContext);

  if (!context) {
    throw new Error(
      "usePageContextDelivery must be used within a PageContextDeliveryProvider",
    );
  }

  return context;
}
